import { createFileRoute } from '@tanstack/react-router'

import { WithdrawalSmz } from '@/pages/withdrawal-smz'

export const Route = createFileRoute('/_protected/withdrawal-smz/')({
    component: WithdrawalSmz,
})
